import { useTranslation } from 'next-i18next';
import propTypes from 'prop-types';

import { NS } from '@/constants';

import styles from './DisplayNbProducts.module.scss';

const DisplayNbProducts = ({ nbTotalRows, customClassName }) => {
  const { t } = useTranslation([NS.CATEG]);

  const className = [
    styles.container,
    customClassName && customClassName
  ].filter(Boolean).join(' ');

  return (
    <div className={className}>
      {t('results.total_plural', { ns: NS.CATEG, count: nbTotalRows })}
    </div>
  );
};

DisplayNbProducts.propTypes = {
  nbTotalRows: propTypes.number,
  customClassName: propTypes.string
};

export default DisplayNbProducts;
